import { cn } from '@/lib/utils'
import logoImage from '@/assets/herzensempfehlung-logo.png'

interface LogoProps {
  className?: string
  size?: 'sm' | 'md' | 'lg' | 'xl'
}

const sizeClasses = {
  sm: 'h-4 w-4',
  md: 'h-6 w-6', 
  lg: 'h-8 w-8',
  xl: 'h-10 w-10'
}

export const Logo = ({ className, size = 'md' }: LogoProps) => {
  return (
    <img 
      src={logoImage} 
      alt="Herzensempfehlung Logo" 
      className={cn(sizeClasses[size], className)}
    />
  )
}

export default Logo